import { h, ComponentChildren, Fragment } from 'preact'; /** @jsx h */
import { useEffect } from 'preact/hooks';

import { useAuth } from "./AuthProvider";
import { useLocation } from 'preact-iso';

export type IProtectedRouteProps = {
    children?: ComponentChildren; 
    loginRoute: string;
};


export const ProtectedRoute = (props: IProtectedRouteProps) => {
    
    const { token } = useAuth();
    const location = useLocation();
    
    useEffect(() => {
        if (token == undefined) {
            location.route(props.loginRoute);
        }
    }, [token, location]);

    return <Fragment>
        { props.children }
    </Fragment>
}
